<template>
	<div class="component-index mt-2">
		<!-- <FunctionTitle :title="mainTitle" /> -->
		<CommonFlame :title="title">
			<v-row no-gutters class="mb-2 ml-2 flex-row-reverse">
				<v-btn color="primary" @click="openSearchDialog">
					<v-icon class="mr-1">mdi-magnify</v-icon>
					検索
				</v-btn>
			</v-row>
			<div>
				<div class="table-container px-2">
					<v-data-table
						locale="ja-JP"
						:headers="headers"
						:items="drawings"
						:mobile-breakpoint="240"
						hide-default-footer
						disable-filtering
						disable-pagination
						disable-sort
						no-data-text="データがありません。"
					>
						<template v-slot:item="{ item, index }">
							<DrawingsRecord :recordIndex="index" :drawing="item" />
						</template>
					</v-data-table>

					<PaginationModule :pagination="pagination" @get-page="getPage($event)"></PaginationModule>
				</div>
			</div>
		</CommonFlame>
		<DrawingsSearchDialog ref="search" @searchDrawing="searchDrawing" />
	</div>
</template>

<script>
import axios from "axios"
import moment from "moment/min/moment.min.js"
import Qs from "qs"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import rules from "../../helper/rules"
import PaginationModule from "../../modules/PaginationModule.vue"

import CommonFlame from "../shared/CommonFlame.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"
import DrawingsRecord from "./components/DrawingsRecord.vue"
import DrawingsSearchDialog from "./components/DrawingsSearchDialog.vue"
export default {
	components: {
		CommonFlame,
		FunctionTitle,
		PaginationModule,
		DrawingsRecord,
		DrawingsSearchDialog,
	},
	data() {
		return {
			mainTitle: "",
			title: "図面台帳",
			headers: [],
			drawings: [],
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			searchedFlag: false,
			searchWord: null,
			selected: null,
		}
	},
	filters: {
		dateFormatter: function (date) {
			if (!date) return ""
			return moment(date).format("YYYY/MM/DD")
		},
	},
	mounted() {
		this.setTableHeaders()
		this.fetchDrawings(1)
	},
	methods: {
		searchDrawing(searchWord, selected) {
			this.searchWord = searchWord
			this.selected = selected
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/drawings_search.json", {
					headers,
					params: { word: this.searchWord, selected: this.selected, page: this.pagination.current },
				})
				.then((res) => {
					this.drawings = res.data.drawings
					console.log(this.drawings)
					this.pagination = res.data.pagination
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		getPage(i) {
			if (this.searchedFlag) {
				this.searchDrawing(this.searchWord, this.selected)
			} else {
				this.fetchDrawings(i)
			}
		},
		openSearchDialog() {
			this.$refs.search.openDialog()
		},
		fetchDrawings(page) {
			const headers = authenticate.setHeader()
			axios
				.get(`/erp/v1/drawings`, { params: { page: page }, headers })
				.then((res) => {
					this.drawings = res.data.drawings
					this.pagination = res.data.pagination
					console.log(res.data)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		setTableHeaders() {
			this.headers = [
				{
					text: "図面番号",
					value: "file_number",
					width: "135px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "状態",
					value: "condition",
					width: "75px",
					filter: null,
					class: "px-1 font-size-075rem",
				},

				{
					text: "社外秘",
					value: "confidential",
					width: "50px",
					filter: null,
					class: "px-1 font-size-075rem",
				},

				{
					text: "ファイル名",
					value: "name",
					width: "100%",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "アップロード日",
					value: "uploading_date",
					width: "135px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "作成者",
					value: "user",
					width: "135px",
					filter: null,
					class: "px-1 font-size-075rem",
				},

				{
					text: "案件",
					value: "matter",
					width: "200px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
				{
					text: "削除",
					value: "status",
					width: "50px",
					filter: null,
					class: "px-1 font-size-075rem",
				},
			]
		},
	},
	computed: {},
}
</script>
